import React, {Component} from 'react';
import { Info } from './svg';

export default class Tooltip extends Component {
   constructor(props) {
      super(props);
   }

   render() {
      let { tip } = this.props;
      return (
         <span className="mp-tooltip hint--top hint--rounded hint--large hint--no-animate" data-hint={tip}>
            <Info />
         </span>
      );
   }
}